import React from "react"
import IconButton from "@material-ui/core/IconButton"
import {
  EditIcon,
  DeleteIcon,
  SaveIcon,
  CancelIcon,
  VisibilityIcon,
} from "@iconsGallery"
import { colors, Tooltip } from "@material-ui/core"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"
import StopRoundedIcon from "@material-ui/icons/StopRounded"
import { useTranslation } from "react-i18next"
import * as QA_Automation from "@qaAutomation"

function IconMenu(props) {
  const {
    isDisableViewIcon = false,
    isDisableSaveButton = false,
    isDisableEditIcon = true,
    showCopyIcon = false,
    isDisableDeleteButton = false,
    showPauseIcon = false,
    showDeleteIcon = false,
    isInlineEditAllowed = false,
    data = {},
    moduleName = "",
    columnData = [],
  } = props || {}
  const { t } = useTranslation()

    const [xTestIdPickNameField = {}] =
      columnData?.filter((item) => {
        const { testIdPickNameField = false } = item || {}
        return testIdPickNameField
      }) || []
  
    const { field: testIdPickNameFieldKit = "" } = xTestIdPickNameField || {}
  
    let testIdValue = props["data"][testIdPickNameFieldKit] || ""
    if (testIdValue) {
      testIdValue = testIdValue.toLowerCase()
      testIdValue = testIdValue.replaceAll(" ", "-")
    }
  
    let testIdEditIcon = QA_Automation?.doAddOnTestIdKendoActionMenuEditIcon(testIdValue)
    let testIdViewIcon = QA_Automation?.doAddOnTestIdKendoMenuViewIcon(testIdValue)
    let testIdDeleteIcon = QA_Automation?.doAddOnTestIdKendoMenuDeleteIcon(testIdValue)
    let testIdStopIcon =  QA_Automation?.doAddOnTestIdKendoMenuStopIcon(testIdValue)
    let testIdCancelIcon = QA_Automation?.doAddOnTestIdKendoCancelStopIcon(testIdValue)
    let testIdSaveIcon = QA_Automation?.doAddOnTestIdKendoSaveStopIcon(testIdValue)
    let testIdCopyIcon = QA_Automation?.doAddOnTestIdKendoCopyStopIcon(testIdValue)


  let isDeleteIcon =
    moduleName === "trainingProd"
      ? (showPauseIcon || showDeleteIcon) &&
        (data?.status === "Stopped" ||
          data?.status === "Failed" ||
          data?.status === "Completed" ||
          data?.progress === 0)
      : props.isInlineEditAllowed

  return (
    <div style={{ textAlign: "center" }}>
      {props.data.inEdit ? (
        <>
          <IconButton
            color="primary"
            aria-label="Save"
            component="span"
            onClick={(...e) => !props.data.saveBTNdisabled && props.save(e)}
            disabled={isDisableSaveButton}
            style={
              props.data.saveBTNdisabled
                ? {
                    color: "rgba(0, 0, 0, 0.5)",
                    cursor: "not-allowed",
                  }
                : {}
            }
            {...testIdSaveIcon}
          >
            <SaveIcon
              style={{
                color: isDisableSaveButton ? "grey" : colors.green[600],
              }}
            />
          </IconButton>
          <IconButton
            color="primary"
            aria-label="Cancel changes"
            component="span"
            onClick={props.cancel}
             {...testIdCancelIcon}
          >
            <CancelIcon style={{ color: colors.red[400] }} />
          </IconButton>
        </>
      ) : (
        <>
          {isDisableViewIcon === false && (
            <Tooltip title={t("VIEW")} placement="top">
              <IconButton
                color="primary"
                aria-label="Visiblity"
                component="span"
                onClick={props.in_edit}
                 {...testIdViewIcon}
              >
                <VisibilityIcon
                  onClick={props.view}
                  style={{ color: "var(--primaryColor)" }}
                />
              </IconButton>
            </Tooltip>
          )}
          {isDisableEditIcon === true && (
            <IconButton
              color="primary"
              aria-label="Edit"
              component="span"
              onClick={props.in_edit}
              disabled={!props.isInlineEditAllowed}
              {...testIdEditIcon}
            >
              <EditIcon
                style={{
                  color: !props.isInlineEditAllowed
                    ? ""
                    : "var(--primaryColor)",
                }}
              />
            </IconButton>
          )}
          {showPauseIcon && showDeleteIcon && (
            <Tooltip title={t("STOP")} placement="top">
              <IconButton
                color="primary"
                aria-label="Delete"
                component="span"
                onClick={props.stop}
                disabled={
                  data?.status === "Stopped" ||
                  data?.status === "Failed" ||
                  data?.progress === 100
                }
                {...testIdStopIcon}
              >
                <StopRoundedIcon
                  style={{
                    border:
                      data?.status === "Stopped" ||
                      data?.status === "Failed" ||
                      data?.progress === 100
                        ? "1px solid #bdbdbd"
                        : "1px solid var(--primaryColor)",
                    borderRadius: "50px",
                    color:
                      data?.status === "Stopped" ||
                      data?.status === "Failed" ||
                      data?.progress === 100
                        ? "#bdbdbd"
                        : "var(--primaryColor)",
                  }}
                />
              </IconButton>
            </Tooltip>
          )}
          {isDisableDeleteButton === false && (
            <Tooltip title={t("DELETE")} placement="top">
              <IconButton
                color="primary"
                aria-label="Delete"
                component="span"
                onClick={props.delete}
                disabled={isDeleteIcon ? false : true}
                {...testIdDeleteIcon}
              >
                <DeleteIcon
                  style={{
                    color: isDeleteIcon ? "var(--primaryColor)" : "",
                  }}
                />
              </IconButton>
            </Tooltip>
          )}

          {showCopyIcon === true && (
            <IconButton
              color="primary"
              aria-label="Copy"
              component="span"
              onClick={props?.copy}
              {...testIdCopyIcon}
            >
              <FileCopyOutlinedIcon
                style={{
                  color: !props.isInlineEditAllowed
                    ? ""
                    : "var(--primaryColor)",
                }}
              />
            </IconButton>
          )}
        </>
      )}
    </div>
  )
}
export default IconMenu
